export const POST_SALON_DATA_REQUEST = 'POST_SALON_DATA_REQUEST';
export const POST_SALON_DATA_SUCCESS = 'POST_SALON_DATA_SUCCESS';
export const POST_SALON_DATA_FAILURE = 'POST_SALON_DATA_FAILURE';
